export function addEnUsLocally(pathname: string): string {
	const hasEnUs = /^\/en-us/.test(pathname);
	const isDirect = /^http|https/.test(pathname);
	const isLocalHost = location.hostname === 'localhost';
	return !hasEnUs && !isDirect && isLocalHost ? `/en-us${pathname}` : pathname;
}
